import React from 'react';
import './Stat.css'

const Stat = (props) => {
    return ( 
        <div className='Stat'>
            <p className='StatNum'>{props.StatNum}</p>
            <p className='StatName'>{props.StatName}</p>
            <p className='StatSub'>{props.StatSub}</p>
        </div>
     );
}
 
export default Stat;    